import useGuards from "api/Other/useGuards";
import useSearchParams from "hooks/useSearchParams";
import { useEffect, useRef } from "react";
import toast from "react-hot-toast";
import { Link, useLocation } from "react-router-dom";
import { getFlushErrorMessage } from "utils/errors";
import { resolveSafeInternalPath, withReturnUrl } from "utils/intendedUrl";

const GUARDED_ACCOUNT_PATHS = ["/my-account", "/my-account/publisher", "/my-account/institution"];

const PortalAccessNotice = () => {
	const location = useLocation();
	const { getParam } = useSearchParams();
	const code = getParam("code") || getParam("flushError");
	const isGuardedPage = GUARDED_ACCOUNT_PATHS.includes(location.pathname);
	const { data: guards, isFetched } = useGuards({ enabled: isGuardedPage });
	const toastedCode = useRef(null);
	const blocker = guards?.blocker;
	const blockerMatchesPage = blocker?.redirectPath === location.pathname;
	const message = blocker?.message || (!isFetched ? getFlushErrorMessage(code) : "");
	const showNotice = isGuardedPage && Boolean(message);
	const nextPath =
		blocker && !blockerMatchesPage
			? withReturnUrl(blocker.redirectPath, {
					returnUrl: resolveSafeInternalPath(getParam("returnUrl")),
					code: blocker.code,
			  })
			: null;

	useEffect(() => {
		if (!showNotice || !code || toastedCode.current === code) {
			return;
		}

		toastedCode.current = code;
		toast.error(message);
	}, [code, message, showNotice]);

	if (!showNotice) {
		return null;
	}

	return (
		<div
			role="status"
			className="mb-6 rounded-xl border border-amber-200 bg-amber-50 px-4 py-3 text-sm text-amber-950"
		>
			<p className="font-medium text-amber-900">Portal access is on hold</p>
			<p className="mt-1 leading-relaxed">{message}</p>
			{nextPath && (
				<Link to={nextPath} className="mt-2 inline-block font-medium text-amber-950 underline">
					Continue to the required page
				</Link>
			)}
			{blockerMatchesPage && blocker?.canSelfResolve === false && (
				<p className="mt-2 text-amber-800">
					You cannot unlock the portal from this page until this is resolved.
				</p>
			)}
		</div>
	);
};

export default PortalAccessNotice;
